import ImageOne from "../images/img22.jpg";
// import ImageTwo from "../images/img20.jpg";

export const InfoData = {
  heading: "Explore New Career Opportunities",
  paragraphOne:
    "Hanna, Mitchell & Associates have been a leader for over 15 years in the Finance and Accounting Recruitment Industry in Southern California.  Our partners are hands on  and  have their fingers on the pulse of the marketplace. We work closely with CFO’s, Directors and Accounting Managers on a personal level to understand their needs and perform a “deep” search for high quality passive career oriented candidates to present.  Our methodology consists of a thorough understanding of a prospective candidate’s professional background, as well as both their short term and long term career and personal goals.  We then map a game plan and show a career path to reach those goals.",
  paragraphTwo:
    "In today’s marketplace, skill sets are the currency that allows Accounting and Finance professionals opportunities for career advancement.  By capitalizing on your current skill set, and gaining additional skills and duties, top candidates can have control over where they are heading, and can not only be on the career path they envision, but doors will open they may not be aware of or haven’t even given thought to.  Our forte is guiding candidates through this process, by developing and maintaining a strong long term business relationship.  Many of our candidates move into executive management over the course of their career.  We provide the personal touch and ongoing service to help our candidates achieve career growth and lifelong success.",
  buttonLabel: "View Openings",
  image: ImageOne,
  reverse: false,
  delay: 100,
};

// export const InfoDataTwo = {
//   heading: "MOdern Designs",
//   paragraphOne: "lorem",
//   paragraphTwo: "loremmmdsfadfds",
//   buttonLabel: "View Homes",
//   image: ImageTwo,
//   reverse: true,
//   delay: 300,
// };
